<template>
  <div>
    <VTableLocal
      :iconHeader="null"
      :items="displayedController"
      customClass="deepTable"
      :isSearchable="false"
      :isSelectable="false"
      :disablePagination="true"
      :headers="tableHeaders"
      :showRowIcon="true"
      :isCustomIconNext="true"
      :itemActions="itemActions"
      :centerColumns="['action']"
      @iconAction="onClickAction"
    />
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import VTableLocal from '@/components/shared/content-views/VTableLocal';
import Vue from 'vue';
import ConfirmForm from '@/components/shared/widgets/ConfirmForm.vue';
import ProbeForm from './ProbeForm.vue';

export default {
    components: {
        VTableLocal,
    },
    props: {
        controllerId: {
            type: String,
            default: '',
        },
        probes: {
            type: Array,
            default: () => [],
        },
    },
    data() {
        return {
            loading: false,
        };
    },
    computed: {
        ...mapGetters([
            'hasPermission',
            'site',
        ]),
        tableHeaders() {
            return [
                {
                    text: this.$t('devices.probes.name'),
                    value: 'name',
                    sortable: false,
                },
                {
                    text: this.$t('devices.probes.id'),
                    value: 'probeId',
                    sortable: false,
                },
                {
                    text: this.$t('devices.probes.analysis'),
                    value: 'linkedAnalysis',
                    sortable: false,
                },
                {
                    text: this.$t('forms.labels.network'),
                    value: 'networkName',
                    sortable: false,
                },
                {
                    text: this.$t('devices.component'),
                    value: 'linkedComponent',
                    sortable: false,
                },

            ];
        },
        itemActions() {
            const actions = [];
            if (this.hasPermission('controllers.edit')) {
                actions.push({
                    name: this.$t('devices.probes.edit'),
                    icon: 'edit',
                    action: 'edit',
                });
            }
            if (this.hasPermission('controllers.remove')) {
                actions.push({
                    name: this.$t('devices.probes.remove'),
                    icon: 'delete',
                    action: 'delete',
                    iconAndTextColor: '#EF4135',
                });
            }
            return actions;
        },
        displayedController() {
            return this.probes.length ? this.probes.map(probe => ({
                ...probe,
                linkedAnalysis: probe.analysisType ? probe.analysisType.name : '',
                linkedComponent: probe.component ? probe.component.name : '',
            })) : [];
        },
    },
    methods: {
        async onClickAction(item, action) {
            switch (action.action) {
                case 'delete':
                    await this.deleteProbe(item);
                    break;
                case 'edit':
                    await this.updateProbe(item);
                    break;
                default:
                    break;
            }
        },

        async updateProbe(probe) {
            this.$root.$emit('showModal', {
                title: this.$t('controller.probe.edit'),
                component: Vue.component('ProbeForm', ProbeForm),
                payload: { probe, editMode: true },
                onConfirm: async requestPayload => {
                    await this.$rq.editProbe(this.site.id, this.controllerId, probe.id, requestPayload);
                },
                isForm: true,
            });
        },

        async deleteProbe(probe) {
            this.$root.$emit('showModal', {
                title: this.$t('controller.probe.remove'),
                component: Vue.component('confirmRemove', ConfirmForm),
                payload: { msg: this.$t('controller.probe.removeMsg') },
                onConfirm: async () => {
                    await this.$rq.deleteProbe(this.site.id, this.controllerId, probe.id);
                    this.$emit('reloadController');
                },
                isForm: false,
            });
        },
    },
};
</script>
